import { render } from "./AdminCertificados.vue?vue&type=template&id=7d22bf8c"
import script from "./AdminCertificados.vue?vue&type=script&lang=js"
export * from "./AdminCertificados.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__